module.exports = __webpack_public_path__ + "img/amicitia.d77b5666.jpg";